import React, { useEffect, useState } from 'react'
import HeadingArea from '../../general/HeadingArea';
import { FaFileImage, FaFilePdf } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';

const ApproveLeave = ({setLoading}) => {
    const [leaveList, setLeaveList] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [showStatus, setShowStatus] = useState(false);
const [selectedReq, setSelectedReq] = useState('');
  const [response2, setResponse2] = useState({ message: '', status: 'success' });

          const fetchMyLeaves = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-apply-leave');
      
                      if (response.ok) {
                          const data = await response.json();
                          setLeaveList(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }


  useEffect(() => {
        fetchMyLeaves();
    }, [])


    const filteredLeave = leaveList.filter((cls) => {
  const term = searchTerm.toLowerCase();
  return (
    cls.addedby_name.toLowerCase().includes(term) ||
        cls.leave_type.toLowerCase().includes(term) ||
        cls.status.toLowerCase().includes(term)
  );
});


const handleShow = (item) => {
  setShowStatus(true);
  setSelectedReq(item);
}


              const handleDisable = async (dId, status) => {

                setLoading(true);
    try {
const response = await fetch(`https://api.kcian.in/handle-leave-status/${dId}`, {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ status: status }),
});

                setLoading(false);

      if (response.ok) {
setLeaveList((prevData) =>
        prevData.map((hw) => (hw.id == dId ? { ...hw, status: status } : hw))
      );
              setShowStatus(false);
        setResponse2({ message: `Leave ${status}.`, status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      }
    } catch (error) {
                        setLoading(false);

      console.error('Error deleting data:', error);
    }
  };


        const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} `;
    };


    return (
<>
<section className='py-4'>

        <div className="px-4">
            <HeadingArea message1="Leave" message2="Approve Leave Request" />

            {/* table */}
        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

            <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100 w-100 mt-4'>
                <div className='profile-card'>
                    <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                        <span className="profile-heading align-content-center">Leave Requests</span>

                        <div className='profile-input-area ms-auto col-lg-3 border-0'>
                            <input
                                type='text'
                                name='search'
                                className='profile-input border-bottom rounded-0'
                                placeholder='Search...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table w-100">
                            <thead className='account-thead'>
                        <th className="rounded-start-4">S No</th>
                        <th>Apply On</th>
                        <th>Applied By</th>
                        <th>Type</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Reason</th>
                        <th>Attachment</th>
                        <th>Status</th>
                        <th className="rounded-end-4">Action</th>
                            </thead>

                    <tbody>
                      {filteredLeave.length === 0 ? (
                        <tr className="account-tr text-center">
                          <td colSpan="7">No leaves applied yet.</td>
                        </tr>
                      ) : (
                        filteredLeave.map((leave, index) => (
                          <tr key={index} className="account-tr">
                            <td>{index + 1}</td>
                            <td>{formatDate(leave.apply_on)}</td>
                            <td>{leave.addedby_name} ({leave.designation})</td>
                            <td>{leave.leave_type}</td>
                            <td>{formatDate(leave.leave_from)}</td>
                            <td>{formatDate(leave.leave_to)}</td>
                            <td>{leave.reason}</td>
                                                                        <td>
                                                {leave.file ? (() => {
                                                    // Extract file extension
                                                    const ext = leave.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${leave.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                            <td>{leave.status}</td>
                            
        <td className='py-3 cursor-pointer'><span className='profile-btn2' onClick={() => handleShow(leave)}>Approve / Reject</span></td>
                          </tr>
                        ))
                      )}
                    </tbody>

                        </table>
                    </div>

                </div>
            </div>
        </div>           

        </section>


    {showStatus && (
      <>

        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Approve This Leave!</p>

<div className='table-responsive mb-4'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Apply On</th>
                        <th>Applied By</th>
                        <th>Type</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Reason</th>
                        <th>Attachment</th>
                            <th className='rounded-end-4'>Status</th>
</thead>

<tr className='account-tr'>
                            <td>{formatDate(selectedReq.apply_on)}</td>
                            <td>{selectedReq.addedby_name} ({selectedReq.designation})</td>
                            <td>{selectedReq.leave_type}</td>
                            <td>{formatDate(selectedReq.leave_from)}</td>
                            <td>{formatDate(selectedReq.leave_to)}</td>
                            <td>{selectedReq.reason}</td>
                                                                        <td>
                                                {selectedReq.file ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedReq.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedReq.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                            <td>{selectedReq.status}</td>
                      </tr>

</table>
</div>

            <button className='profile-btn me-2' onClick={() => handleDisable(selectedReq.id, 'Approved')}>Approve</button>
            <button className='profile-btn me-2' onClick={() => handleDisable(selectedReq.id, 'Rejected')}>Reject</button>
            <button className='profile-btn2' onClick={() => setShowStatus(false)}>Go Back</button>


</div> 
</section>
      </>
    )}



</>

    )
}

export default ApproveLeave